'use client';

import dynamic from 'next/dynamic';

export const DivisionGroupsDemo = dynamic(
  () => import('./DivisionGroupsDemo/DivisionGroupsDemo')
);

export const CircularColorsDemo = dynamic(
  () => import('./CircularColorsDemo/CircularColorsDemo')
);
